import { BcfAppId } from '@bcf-v2-configurators/tokens/app/types';

export const bcfAppId: BcfAppId = 'cs-lvbetlv-mobile-web-twa';
